import React from 'react';
import './SectionOne.scss';

const SectionOne = () => {
  const cardsData = [
    {
      title: 'MIS & DASHBOARDS',
      desc: 'Automated reporting • business pulse • drill-down',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="14" width="4" height="6" rx="1" fill="#FF6516" stroke="none"/>
          <rect x="10" y="10" width="4" height="10" rx="1" fill="#FF6516" stroke="none"/>
          <rect x="17" y="4" width="4" height="16" rx="1" fill="#FF6516" stroke="none"/>
        </svg>
      )
    },
    {
      title: 'FP&A & SIMULATION',
      desc: 'Connected plans • rolling forecasts • scenarios',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 20L10 14L14 18L20 8" stroke="#FF6516"/>
          <path d="M20 8V13" stroke="#FF6516"/>
          <path d="M20 8H15" stroke="#FF6516"/>
          <rect x="2" y="2" width="20" height="20" rx="4" stroke="#FF6516" opacity="0.3"/>
        </svg>
      )
    },
    {
      title: 'S&OP & DEMAND',
      desc: 'Demand sensing • forecasting • sales interventions',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" stroke="#FF6516"/>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" stroke="#FF6516"/>
          <line x1="12" y1="22.08" x2="12" y2="12" stroke="#FF6516"/>
        </svg>
      )
    },
    {
      title: 'WORKING CAPITAL',
      desc: 'Inventory • receivables • cash optimization',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <ellipse cx="12" cy="5" rx="9" ry="3" fill="#FF6516" stroke="none" opacity="0.8"/>
          <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" stroke="#FF6516"/>
          <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke="#FF6516"/>
          <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" stroke="#FF6516"/>
        </svg>
      )
    },
    {
      title: 'PERFORMANCE',
      desc: 'KPI gaps • initiatives • accountability • impact',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" stroke="#FF6516"/>
          <circle cx="12" cy="12" r="6" stroke="#FF6516"/>
          <circle cx="12" cy="12" r="2" fill="#FF6516" stroke="none"/>
        </svg>
      )
    },
    {
      title: 'OPERATIONS & ASSETS',
      desc: 'Production • productivity • assets • projects',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3" stroke="#FF6516" fill="#FF6516"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="#FF6516"/>
        </svg>
      )
    }
  ];

  return (
    <div className="EPMSection">
      {/* Top Header Section */}
      <div className="EPMSection-header">
        <span className="eyebrow">PRE-BUILT APPLICATIONS</span>
        <h1 className="main-title">
          Start with the Business Problem — <br />
          Not with a Technology Build
        </h1>
        <p className="sub-title">
          EPMTech combines a common performance system with pre-built applications <br />
          that can be deployed selectively and connected over time.
        </p>
      </div>

      {/* Bottom Content Section */}
      <div className="EPMSection-content">
        <div className="cards-container">
          {cardsData.map((card, index) => (
            <div className="card" key={index}>
              <div className="icon-wrapper">
                {card.icon}
              </div>
              <div className="text-wrapper">
                <h3 className="card-title">{card.title}</h3>
                <p className="card-desc">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Flow Process */}
        <div className="process-flow">
          <div className="line"></div>
          <span className="flow-text">Deploy one application</span>
          <svg className="arrow" viewBox="0 0 24 24" fill="none" stroke="#FF6516" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
          <span className="flow-text">prove value</span>
          <svg className="arrow" viewBox="0 0 24 24" fill="none" stroke="#FF6516" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
          <span className="flow-text">connect adjacent processes</span>
          <svg className="arrow" viewBox="0 0 24 24" fill="none" stroke="#FF6516" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
          <span className="flow-text">compound enterprise impact</span>
          <div className="line"></div>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;